import axios from 'axios';

const API_URL = '/api/board';
const CODE_API_URL = '/api/board-codes';

// 게시글 작성
export const createPost = async (formData, token) => {
  const res = await axios.post(API_URL, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
};


// 게시물 목록 조회
export const getPosts = async (page, limit, search = '', code_id = '') => {
  const res = await axios.get(API_URL, {
    params: { page, limit, search, code_id },
  });
  return res.data; // { posts, total }
};


// 게시글 단건 조회
export const getPostById = async (id) => {
  const res = await axios.get(`${API_URL}/post/${id}`);
  return res.data; // post 객체 (files 포함)
};

// 게시글 삭제
export const deletePost = async (id, token) => {
  const res = await axios.delete(`${API_URL}/post/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// -------------------- 응답 --------------------

// 응답 작성 (FormData)
export const createResponse = async (formData, token) => {
  const res = await axios.post(`${API_URL}/response`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      // Content-Type은 axios가 자동 처리
    },
  });
  return res.data;
};

// 응답 단건 조회
export const getResponseById = async (id, token) => {
  const res = await axios.get(`${API_URL}/response/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 응답 수정 (JSON)
export const updateResponse = async (id, data, token) => {
  const res = await axios.put(`${API_URL}/response/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 응답 삭제
export const deleteResponse = async (id, token) => {
  const res = await axios.delete(`${API_URL}/response/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 응답 파일 업로드 (FormData)
export const uploadResponseFiles = async (id, formData, token) => {
  const res = await axios.post(`${API_URL}/response/${id}/files`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      // Content-Type은 axios가 자동 처리
    },
  });
  return res.data;
};


// 댓글 목록 조회
export const getCommentsByPostId = async (postId) => {
  const res = await axios.get(`${API_URL}/post/${postId}/comments`);
  return res.data;
};

// 댓글 작성 (새 댓글 또는 답글)
export const createComment = async (data, token) => {
  const res = await axios.post(`${API_URL}/comments`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 댓글 삭제
export const deleteComment = async (commentId, token) => {
  const res = await axios.delete(`${API_URL}/comments/${commentId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 댓글 수정
export const updateComment = async (commentId, data, token) => {
  const res = await axios.put(`${API_URL}/comments/${commentId}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 게시글 수정 (제목/내용 + 삭제할 파일 ID)
export const updatePost = async (id, data, token) => {
  const res = await axios.put(`${API_URL}/post/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 게시글 파일 업로드 (새 파일 추가)
export const uploadPostFiles = async (id, formData, token) => {
  const res = await axios.post(`${API_URL}/post/${id}/files`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
};

// 📌 게시판 코드 단건 조회 (code_id → name 가져오기)
export const getBoardCodeById = async (code_id) => {
  const res = await axios.get(`${CODE_API_URL}/${code_id}`);
  return res.data; // { id, code, name, description, ... }
};

// -------------------- 게시판 권한 --------------------

// 게시판 권한 전체 조회
export const getBoardAuths = async () => {
  const res = await axios.get(`${CODE_API_URL}/auths`);
  return res.data;
};

// 게시판별 권한 조회
export const getBoardAuthsByBoard = async (board_code) => {
  const res = await axios.get(`${CODE_API_URL}/auths/board/${board_code}`);
  return res.data;
};

// 대상별 권한 조회
export const getBoardAuthsByTarget = async (target_type, target_id) => {
  const res = await axios.get(`${CODE_API_URL}/auths/target/${target_type}/${target_id}`);
  return res.data;
};

// 특정 권한 조회
export const getBoardAuth = async (board_code, target_type, target_id, auth_type) => {
  const res = await axios.get(`${CODE_API_URL}/auths/${board_code}/${target_type}/${target_id}/${auth_type}`);
  return res.data;
};

// 게시판 권한 생성
export const createBoardAuth = async (data, token) => {
  const res = await axios.post(`${CODE_API_URL}/auths`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 게시판 권한 일괄 생성
export const createBoardAuthsBulk = async (data, token) => {
  const res = await axios.post(`${CODE_API_URL}/auths/bulk`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 게시판 권한 수정
export const updateBoardAuth = async (board_code, target_type, target_id, auth_type, data, token) => {
  const res = await axios.put(`${CODE_API_URL}/auths/${board_code}/${target_type}/${target_id}/${auth_type}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 게시판 권한 삭제
export const deleteBoardAuth = async (board_code, target_type, target_id, auth_type, token) => {
  const res = await axios.delete(`${CODE_API_URL}/auths/${board_code}/${target_type}/${target_id}/${auth_type}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 게시판별 권한 전체 삭제
export const deleteBoardAuthsByBoard = async (board_code, token) => {
  const res = await axios.delete(`${CODE_API_URL}/auths/board/${board_code}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 대상별 권한 전체 삭제
export const deleteBoardAuthsByTarget = async (target_type, target_id, token) => {
  const res = await axios.delete(`${CODE_API_URL}/auths/target/${target_type}/${target_id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 게시판별 특정 권한을 가진 사용자 목록 조회
export const getUsersWithAuth = async (board_code, auth_type) => {
  const res = await axios.get(`${CODE_API_URL}/auths/users/${board_code}/${auth_type}`);
  return res.data;
};

// 게시판별 특정 권한을 가진 부서 목록 조회
export const getDeptsWithAuth = async (board_code, auth_type) => {
  const res = await axios.get(`${CODE_API_URL}/auths/depts/${board_code}/${auth_type}`);
  return res.data;
};

